import axios, { _get, _post, _delete, _put, _patch } from './index';
// 获取所有问题
export const getPolicyToolsQuestion = (data) => {
  const req = {
    data,
    url: 'zstapi/policyTools',
  };

  return _get(req);
};
// 政策工具列表
export function getToolsPageList(data) {
  const req = {
    data,
    url: 'zstapi/policyTools/toolsPageList',
  };

  return _get(req);
}
// 政策工具关联的政策
export function getPolicyToolsPolicyList(data) {
  const req = {
    data,
    url: 'zstapi/policyTools/policyToolsPolicyList',
  };

  return _get(req);
}
//打分
export const getSelfTestScore = (data) => {
  const req = {
    method: 'post',
    data,
    url: 'zstapi/policyTools/testScore',
    headers:{
      'Content-Type': 'application/json'
    }
  };
  // @ts-ignore
  return axios(req);
};
// 获取政策工具关联的政策数据详情
export function getPolicyToolsPolicyDetails(id) {
  const req = {
    url: `zstapi/data/policy/getById/${id}`,
  };

  return _get(req);
}
// 获取企业信息